import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const RegenerateApiKeyContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RegenerateApiKeyProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching, refetch } = useQuery({
    queryKey: ["api_key"],
    staleTime: 30000,
    enabled: false,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`account/api-keys/regenerate`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      refetch,
      error,
    }),
    [isLoading, data, error, isFetching, refetch],
  );
  return (
    <RegenerateApiKeyContext.Provider value={contextValue}>
      {children}
    </RegenerateApiKeyContext.Provider>
  );
};

export default RegenerateApiKeyProvider;
